// extracted by mini-css-extract-plugin
export default {"map-container":"Xdfq6N_u","map-img":"iobM1grX"};